import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { ToastService, Toast } from './toast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, NgIcon],
  viewProviders: [provideIcons({ heroXMark })],
  template: `
    <div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
      @for (toast of toasts; track toast.id) {
        <div
          [class]="getToastClasses(toast)"
          class="flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg text-sm min-w-[300px] max-w-[420px] animate-slide-in"
        >
          <span class="flex-1">{{ toast.message }}</span>
          <button
            type="button"
            class="text-current opacity-70 hover:opacity-100"
            (click)="dismiss(toast.id)"
          >
            <ng-icon name="heroXMark" size="16"></ng-icon>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes slide-in {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    .animate-slide-in {
      animation: slide-in 0.3s ease-out;
    }
  `],
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private subs: Subscription[] = [];

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.subs.push(
      this.toastService.toasts$.subscribe(toast => {
        this.toasts = [...this.toasts, toast];
      }),
      this.toastService.dismiss$.subscribe(id => {
        this.toasts = this.toasts.filter(t => t.id !== id);
      }),
    );
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  getToastClasses(toast: Toast): string {
    const colors: Record<string, string> = {
      success: 'bg-green-600 text-white',
      error: 'bg-red-600 text-white',
      warning: 'bg-yellow-500 text-black',
      info: 'bg-accent text-white',
    };
    return colors[toast.type ?? 'info'];
  }

  dismiss(id: number) {
    this.toastService.dismiss(id);
  }
}
